import { Entity } from '../../../core/context/entity';
import { UUID } from '../../../core/context/uuid/entity';
import { type ResponsibleData } from './dto';

export class Responsible extends Entity {
    description: string;
    name: string;

    constructor({ id, name, description }: ResponsibleData) {
        super({ id });
        this.name = name;
        this.description = description;
    }

    static new(data: Omit<ResponsibleData, 'id'>): Responsible {
        const uuid = new UUID();
        return new Responsible({
            id: uuid.toString(),
            ...data,
        });
    }
}
